export enum LessonAccessState {
  Accessible = 'ACCESSIBLE',
  NotAccessible = 'NOT_ACCESSIBLE',
  CanEnroll = 'CAN_ENROLL_FOR_ACCESS'
}
